export default function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <div className="w-10 h-10 border-3 border-brand-500 border-t-transparent rounded-full animate-spin mb-4"></div>
      <p className="text-gray-400 text-sm">{message}</p>
    </div>
  );
}
